import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { vendorService } from '@services/VendorService';
import { OptionsViewModel } from '@models/common.models';
import { DynamicSelectIdentifier } from '@common/components';
import { getTradesSuccess, getTradesFailure, searchVendors } from '../vendor-dashboard.actions';
import { VendorDashboardComponentProperties, VendorDashboardComponent } from './vendor-dashboard.component';

function mapStateToProps(state: AppState, ownProps: {}): Partial<VendorDashboardComponentProperties> {
  return {
    message: state.vendorMaintenance.message,
    searchQuery: state.vendorMaintenance.searchQuery,
    searchLoading: state.vendorMaintenance.searchLoading,
    searchPageCount: state.vendorMaintenance.searchPageCount,
    searchPageNumber: state.vendorMaintenance.searchPageNumber,
    searchPageSize: state.vendorMaintenance.searchPageSize,
    vendorSearchResults: state.vendorMaintenance.searchResults,
    searchResultsTotalCount: state.vendorMaintenance.searchResultsTotalCount,

    trade: state.vendorMaintenance.trade,

    trades: state.vendorMaintenance.tradeOptions,

    type: state.vendorMaintenance.type,
    filters: state.dynamicSelect.options[DynamicSelectIdentifier.VendorTypes] || ([] as Array<OptionsViewModel>),
    statusFilters:
      state.dynamicSelect.options[DynamicSelectIdentifier.VendorStatuses] || ([] as Array<OptionsViewModel>),
    status: state.vendorMaintenance.status,
    groupFilters: state.dynamicSelect.options[DynamicSelectIdentifier.VendorGroups] || ([] as Array<OptionsViewModel>),
    group: state.vendorMaintenance.group
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<VendorDashboardComponentProperties> {
  return {
    getTrades() {
      return vendorService
        .getTrades()
        .then(p => dispatch(getTradesSuccess(p)))
        .catch(p => dispatch(getTradesFailure('')))
        .then(() => {
          return;
        });
    },
    searchVendors: (query, pageSize, pageNumber, orderBy, orderDirection, trades, type, status, group) =>
      dispatch(searchVendors(query, pageSize, pageNumber, orderBy, orderDirection, trades, type, status, group))
  };
}

export const VendorDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorDashboardComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-dashboard/_components/vendor-dashboard.container.ts